import { Component, Input } from '@angular/core';
import {
  HygieneInspectionStatus,
  HygieneInspectionStatusLabels,
} from '../../../models/status/hygiene-inspection-status.enum';

import { TooltipModule } from 'primeng/tooltip';
import {
  AggregateInspectionStatus,
  AggregateInspectionStatusLabels,
} from '../../../models/status/aggregate-inspection-status.enum';
import {
  EnergeticInspectionStatus,
  EnergeticInspectionStatusLabels,
} from '../../../models/status/energetic-inspection-status.enum';
import {
  OrderStatus,
  OrderStatusLabels,
} from '../../../models/status/order-status.enum';

@Component({
  selector: 'app-chip',
  standalone: true,
  imports: [TooltipModule],
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.scss',
})
export class ChipComponent {
  @Input() imgSrc = '';
  @Input() status:
    | HygieneInspectionStatus
    | EnergeticInspectionStatus
    | OrderStatus
    | AggregateInspectionStatus
    | undefined;
  @Input() hasText = false;

  readonly statusLabelMap: Record<string, string> = {
    ...OrderStatusLabels,
    ...HygieneInspectionStatusLabels,
    ...EnergeticInspectionStatusLabels,
    ...AggregateInspectionStatusLabels,
  };

  readonly statusImageMap: Record<string, string> = {
    [OrderStatus.Created]: '/assets/icons/edit.svg',
    [OrderStatus.Planned]: '/assets/icons/planned.svg',
    [OrderStatus.InProcessByInspector]:
      '/assets/icons/in_process_by_inspector.svg',
    [OrderStatus.FinishedByInspector]:
      '/assets/icons/finished_by_inspector.svg',
    [OrderStatus.ReadyForShipment]: '/assets/icons/ready_for_shippment.svg',
    [OrderStatus.ShippedToCustomer]: '/assets/icons/shipped_to_customer.svg',
    [HygieneInspectionStatus.Pending]: '/assets/icons/pending.svg',
    [HygieneInspectionStatus.InProgress]: '/assets/icons/in_progress.svg',
    [HygieneInspectionStatus.Completed]: '/assets/icons/completed.svg',
    [HygieneInspectionStatus.WaitingForLab]:
      '/assets/icons/waiting_for_lab.svg',
    [HygieneInspectionStatus.InReview]: '/assets/icons/in_review.svg',
    [EnergeticInspectionStatus.WaitingForData]:
      '/assets/icons/waiting_for_lab.svg',
    [AggregateInspectionStatus.OnGoing]: '/assets/icons/on_going.svg',
    [AggregateInspectionStatus.NotInspected]: '/assets/icons/not_inspected.svg',
    [AggregateInspectionStatus.PartlyInspected]:
      '/assets/icons/partly_inspected.svg',
    [AggregateInspectionStatus.Inspected]: '/assets/icons/inspected.svg',
  };

  getStatusLabel(): string {
    if (this.status) {
      return this.statusLabelMap[this.status] || 'Unknown Status';
    }

    return 'Unknown Status';
  }

  getImageSrc(): string {
    return this.statusImageMap[this.status || ''] || '/assets/default.svg';
  }
}
